import React from 'react';
import './About.css';

import { Button, Heading } from '../../../components'; // Import necessary components from the components directory
import { about, images } from '../../../constants'; // Import the about data and images from the constants directory

import { FaTaxi } from 'react-icons/fa'; // Import the FaTaxi icon from react-icons/fa for use in the experience section



const About = () => {
  return (
    <section className="about">

      {/* About Image */}
      <div className="image">

        <div className="sub-image one">

          <img src={images.about1} alt='Taxi Booking About 1' />

          <div className='image-ex'>
            <img src={images.about2} alt='Taxi Booking About 2' />
            <div className="experience">
              <span>
                <FaTaxi /> {about.experience.years}
              </span> {about.experience.text}
            </div>
          </div>

        </div>

        <div className='sub-image two'>
          <img src={images.about3} alt='Taxi Booking About 3' />
        </div>

      </div>

      {/* About Content */}
      <div className="content">
        <Heading title={about.heading} subTitle={about.sub} sideHeading={true} />

        {/* Description */}
        <p>{about.description}</p>

        {/* Key Features */}
        <ul className="about-features">
          {about.points.map((point, index) => (
            <li key={index}>
              <div className='icon'>{point.icon}</div>
              <span>{point.title}</span>
            </li>
          ))}
        </ul>

        {/* Button Component: Links to a specific page or action */}
        <Button link={about.button.link} title={about.button.text} />

      </div>
    </section>
  );
}

export default About;